function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useState } from "react";
import Flicking from "@egjs/react-flicking";
import { useUIDSeed } from "react-uid";
import { NewsGridCard, PaginationDots, Section, SectionHeader } from "../../molecules";
export var NewsGrid = function(param) {
    var label = param.label, title = param.title, callToActions = param.callToActions, cards = param.cards, className = param.className, enableLines = param.enableLines;
    var seed = useUIDSeed();
    var ref = _slicedToArray(useState(0), 2), activeIndex = ref[0], setActiveIndex = ref[1];
    var handleChangeOrRestore = useCallback(function(event) {
        setActiveIndex(event.index);
    }, []);
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-7 md:gap-10"
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        label: label,
        title: title,
        callToActions: callToActions
    }), /*#__PURE__*/ React.createElement("div", {
        className: "-mx-5"
    }, /*#__PURE__*/ React.createElement(Flicking, {
        preventClickOnDrag: true,
        bound: true,
        align: "prev",
        moveType: "strict",
        onWillChange: handleChangeOrRestore,
        onWillRestore: handleChangeOrRestore
    }, cards.map(function(card) {
        return /*#__PURE__*/ React.createElement("div", {
            key: seed(card),
            className: "flicking-panel shrink-0 w-full px-5 md:w-1/3"
        }, /*#__PURE__*/ React.createElement(NewsGridCard, _extends({}, card)));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "block md:hidden"
    }, /*#__PURE__*/ React.createElement(PaginationDots, {
        count: cards.length,
        activeIndex: activeIndex
    }))));
};

//# sourceMappingURL=NewsGrid.js.map